import { LeadReportStatus } from "helpers/leads/generalReports";

import {
    resolveDateRange,
    validateRange,
} from "../../LeadGeneralReportsPage/LeadGeneralReportsPage.helpers";
import {
    ALL_STATUSES,
    DatePreset,
} from "../../LeadGeneralReportsPage/LeadGeneralReportsPage.types";

export interface LeadHistoryFilters {
    datePreset: DatePreset;
    startDate: string | null;
    endDate: string | null;
    statuses: LeadReportStatus[];
}

export const DEFAULT_LEAD_HISTORY_FILTERS: LeadHistoryFilters = {
    datePreset: "last30",
    startDate: null,
    endDate: null,
    statuses: [...ALL_STATUSES],
};

const asReportFilters = (filters: LeadHistoryFilters) => ({
    ...filters,
    groupBy: "connection" as const,
});

export const getLeadHistoryFilterError = (
    filters: LeadHistoryFilters,
): string => validateRange(asReportFilters(filters)).message ?? "";

/**
 * All statuses selected, or none, means the list is unfiltered. A subset is
 * sent as one comma-separated `status` value.
 */
export const toLeadHistoryQuery = (filters: LeadHistoryFilters) => {
    const { start, end } = resolveDateRange(asReportFilters(filters));
    const allSelected =
        filters.statuses.length === 0 ||
        filters.statuses.length === ALL_STATUSES.length;

    return {
        start_date: start,
        end_date: end,
        status: allSelected ? undefined : filters.statuses.join(","),
    };
};

export const formatHistoryDate = (value: string): string => {
    if (!value) return "—";
    const normalized = value.includes("T") ? value : value.replace(" ", "T");
    const date = new Date(normalized);
    if (Number.isNaN(date.getTime())) return value;
    return date.toLocaleString();
};
